import { toast } from "react-toastify";

// function to round and make value two decimal place
export function roundValue(val) {
    return (Math.round(val * 20) / 20);
}

//function that return the format of the currency provided to that
export function CurrencyFormatter(amount, type) {
    if (type === "aud") {
        return amount.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    } else if (type === "usd") {
        return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    } else if (type === "gbp") {
        return amount.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
    } else if (type === "eur") {
        return '€' + amount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
        return "ERR404"
    }

};

export function getTransactionId(transactionLength) {
    const paddedLength = String(Number(transactionLength) + 1).padStart(6, '0');
    const myId = `CW${paddedLength}`;
    return myId;
}

// function that create the provided date with current time
export function createDateWithCurrentTime(dateInputValue) {
    // Split the input value into [year, month, day]
    const [year, month, day] = dateInputValue.split('-');

    // Get the current time from the local machine
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    // Create a new Date object using the selected date and current time
    const newDate = new Date(year, month - 1, day, hours, minutes, seconds);

    return newDate;
};


// funtion to format currency in invoice
export const formatCurrency = (value, currency = 'AUD') => {
  if (!value) return `${currency} 0.00`;
  return `${currency} ${parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

// funtion to format date in invoice
export const formatDate = (date) => {
  const d = new Date(date);
  return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
};

// funtion to format time in invoice
export const formatTime = (date) => {
  const d = new Date(date);
  const hours = d.getHours() > 12 ? (d.getHours() - 12).toString().padStart(2, '0') : d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  const ampm = d.getHours() >= 12 ? 'PM' : 'AM';
  return `${hours}:${minutes} ${ampm}`;
};

